
/**
 * The number of margin lines when jumping to a particular line.
 *
 * @since 0.1.0
 */
export const JUMP_OFFSET = 1;

/**
 * Throttle duration for the resize function.
 *
 * @since 0.1.0
 */
export const RESIZE_THROTTLE_DURATION = 60;

/**
 * Minimum required amount of the scroll offset to update.
 *
 * @since 0.1.0
 */
export const MIN_SCROLL_DIFF = 3;
